var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "签署设置",
        visible: _vm.signSetVisi,
        width: "35%",
        "close-on-click-modal": false
      },
      on: { close: _vm.closePup }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { model: _vm.formInItem }
        },
        [
          _vm.formInItem.signatoryUserType !== 2
            ? _c(
                "el-form-item",
                { attrs: { label: "意愿认证：" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        "true-label": 11,
                        "false-label": null,
                        checked: _vm.formInItem.authLevel === 11
                      },
                      model: {
                        value: _vm.formInItem.authLevel,
                        callback: function($$v) {
                          _vm.$set(_vm.formInItem, "authLevel", $$v)
                        },
                        expression: "formInItem.authLevel"
                      }
                    },
                    [_vm._v("人脸识别")]
                  ),
                  _vm.formInItem.signatoryUserType == 0
                    ? _c(
                        "el-checkbox",
                        {
                          attrs: {
                            "true-label": 12,
                            "false-label": null,
                            checked: _vm.formInItem.authLevel === 12
                          },
                          model: {
                            value: _vm.formInItem.authLevel,
                            callback: function($$v) {
                              _vm.$set(_vm.formInItem, "authLevel", $$v)
                            },
                            expression: "formInItem.authLevel"
                          }
                        },
                        [_vm._v("短信验证")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.formInItem.signatoryUserType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "签章设置：" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": null },
                      model: {
                        value: _vm.formInItem.extraHandSign,
                        callback: function($$v) {
                          _vm.$set(_vm.formInItem, "extraHandSign", $$v)
                        },
                        expression: "formInItem.extraHandSign"
                      }
                    },
                    [_vm._v("经办人签字")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "强制阅读：" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.formInItem.needRead,
                    callback: function($$v) {
                      _vm.$set(_vm.formInItem, "needRead", $$v)
                    },
                    expression: "formInItem.needRead"
                  }
                },
                [
                  _vm._v("需阅读\n          "),
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { size: "mini", min: 5, max: 300 },
                        model: {
                          value: _vm.formInItem.readTime,
                          callback: function($$v) {
                            _vm.$set(_vm.formInItem, "readTime", $$v)
                          },
                          expression: "formInItem.readTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v("\n          秒并阅读至合同末尾")
                ]
              )
            ],
            1
          ),
          _vm.activeTabsName === _vm.signTypes[1]
            ? _c(
                "el-form-item",
                { attrs: { label: "视频通话：" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": null,
                        disabled: _vm.disOption({
                          faceOrVideo: _vm.formInItem.faceOrVideo
                        })
                      },
                      on: { change: _vm.videoPartIn },
                      model: {
                        value: _vm.formInItem.faceOrVideo,
                        callback: function($$v) {
                          _vm.$set(_vm.formInItem, "faceOrVideo", $$v)
                        },
                        expression: "formInItem.faceOrVideo"
                      }
                    },
                    [_vm._v("参与视频通话")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closePup } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.setConfirm }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30ebb64c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ebb64c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/moreSetting.vue
// module id = w6Gx
// module chunks = 2 3 6 8 229